import type { Equipment } from '../api/types'
import { config } from '../config'
import { QrCode } from './QrCode'

/**
 * QR-mærkatet på et stykke værktøj (beslutning 096).
 *
 * <b>Værktøj har sin egen adresse (`/m/`)</b> - ikke enhedernes (`/e/`) og ikke
 * varernes (`/v/`). Mærkatet kan scannes med mobilens eget kamera, og så åbner
 * telefonen den URL, der står i koden; pegede den på en af de andre, landede man
 * på "findes ikke", selv om værktøjet er der. Tre slags ting, tre stier.
 *
 * Koden står også med tal og bogstaver under QR-koden, så den kan tastes ind,
 * når mærkatet er blevet snavset i en varevogn.
 */

/** URL'en der ender i QR-koden på et stykke værktøj. */
export function equipmentUrl(code: string) {
  const base = config.publicUrl || window.location.origin
  return `${base.replace(/\/$/, '')}/m/${code}`
}

export function EquipmentQr({ code, size = 128 }: { code: string; size?: number }) {
  return <QrCode value={equipmentUrl(code)} size={size} />
}

/**
 * Ét mærkat, som det ser ud på papir.
 *
 * Genbruger enhedsmærkatets stil (`device-label`): samme størrelse, samme
 * printark og samme afstand - to næsten ens sæt regler ville drive fra hinanden.
 */
export function EquipmentLabel({ item }: { item: Equipment }) {
  return (
    <div className="device-label">
      <EquipmentQr code={item.code} size={132} />

      <div className="device-label__text">
        <div className="device-label__name">{item.name}</div>
        {item.identifier && <div className="device-label__line">Mærkning {item.identifier}</div>}
        {item.serialNumber && <div className="device-label__line">Nr. {item.serialNumber}</div>}

        <div className="device-label__code">{item.code}</div>
      </div>
    </div>
  )
}
